// frontend-web/src/pages/Admin/EditQuestion.jsx

// frontend-web/src/pages/Admin/EditQuestion.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api, { fetchQuestionById, updateQuestion } from "../../api";

export default function EditQuestion() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [question, setQuestion] = useState({
    text: "",
    option_a: "",
    option_b: "",
    option_c: "",
    option_d: "",
    correct: "",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadQuestion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // ---- Load Question ----
const loadQuestion = async () => {
  setLoading(true);

  try {
    // API Call (helper function)
    const response = await fetchQuestionById(id);

    // Backend se response structure match kare
    const q = response?.data || {};

    // Form state update
    setQuestion({
      text: q.text ?? "",
      option_a: q.option_a ?? "",
      option_b: q.option_b ?? "",
      option_c: q.option_c ?? "",
      option_d: q.option_d ?? "",
      correct: q.correct ? q.correct.toLowerCase() : "",
    });

  } catch (error) {
    console.error("❌ Failed to load question:", error);
    alert("❌ Unable to load question. Please try again.");
    navigate("/admin/view-questions");
  } finally {
    setLoading(false);
  }
};

  // ---- Update Question ----
const handleUpdate = async () => {
  // Basic validation
  if (!question.text.trim() || !question.correct.trim()) {
    alert("⚠ Please fill all required fields.");
    return;
  }

  try {
    await updateQuestion(id, {
      text: question.text.trim(),
      option_a: question.option_a.trim(),
      option_b: question.option_b.trim(),
      option_c: question.option_c.trim(),
      option_d: question.option_d.trim(),
      correct: (question.correct || "").toUpperCase().trim(),
    });

    alert("✅ Question updated successfully!");
    navigate("/admin/view-questions");

  } catch (error) {
    console.error("❌ Update error:", error);
    alert("❌ Failed to update question. Please try again.");
  }
};

  if (loading) return <p style={{ padding: "40px", textAlign: "center" }}>Loading...</p>;

  return (
    <div style={{ padding: 20, maxWidth: 800, margin: "0 auto" }}>
      <h2>Edit Question #{id}</h2>

      <label style={{ fontWeight: "bold" }}>Question</label>
      <textarea
        rows="4"
        style={{ width: "100%", marginBottom: 12, padding: 10 }}
        value={question.text}
        onChange={(e) => setQuestion({ ...question, text: e.target.value })}
      />

      {["a", "b", "c", "d"].map((opt) => (
        <div key={opt} style={{ marginBottom: 8 }}>
          <label style={{ fontWeight: 600 }}>Option {opt.toUpperCase()}</label>
          <input
            style={{ width: "100%", padding: 8 }}
            value={question[`option_${opt}`]}
            onChange={(e) => setQuestion({ ...question, [`option_${opt}`]: e.target.value })}
          />
        </div>
      ))}

      <label style={{ fontWeight: "bold" }}>Correct Answer</label>
      <select
        value={question.correct || ""}
        onChange={(e) => setQuestion({ ...question, correct: e.target.value })}
        style={{ display: "block", width: "100%", padding: 10, marginBottom: 12 }}
      >
        <option value="">Select</option>
        <option value="a">A</option>
        <option value="b">B</option>
        <option value="c">C</option>
        <option value="d">D</option>
      </select>

      <div style={{ display: "flex", gap: 10 }}>
        <button onClick={handleUpdate} style={{ padding: "10px 18px", background: "#10b981", color: "white", border: "none" }}>
          Save
        </button>
        <button onClick={() => navigate("/admin/view-questions")} style={{ padding: "10px 18px" }}>
          Cancel
        </button>
      </div>
    </div>
  );
}



// ---------------------------- STYLES ----------------------------

const pageStyle = {
  fontFamily: "Inter, system-ui, sans-serif",
  background: "#f8fafc",
  minHeight: "100vh",
  padding: "20px",
};

const headerStyle = {
  background: "white",
  padding: "18px 24px",
  borderRadius: "14px",
  marginBottom: "30px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
};

const backBtn = {
  padding: "10px 18px",
  background: "#6b7280",
  color: "white",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: 600,
};

const formContainer = {
  background: "white",
  padding: "30px",
  borderRadius: "16px",
  maxWidth: "700px",
  margin: "auto",
  boxShadow: "0 6px 25px rgba(0,0,0,0.08)",
};

const label = {
  fontSize: "16px",
  fontWeight: 600,
  marginBottom: "6px",
  display: "block",
};

const input = {
  width: "100%",
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #cbd5e1",
  marginBottom: "18px",
  fontSize: "15px",
};

const textarea = {
  width: "100%",
  minHeight: "100px",
  padding: "14px",
  borderRadius: "10px",
  border: "1px solid #cbd5e1",
  marginBottom: "18px",
  fontSize: "15px",
};

const saveBtn = {
  width: "100%",
  padding: "16px",
  background: "#10b981",
  color: "white",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer",
  fontSize: "18px",
  fontWeight: 700,
  marginTop: "10px",
};
